import { render, staticRenderFns } from "./InputPrice.vue?vue&type=template&id=7b53fc60"
import script from "./InputPrice.vue?vue&type=script&lang=js"
export * from "./InputPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports